<template>
  <div v-if="showModal" class="fixed inset-0 z-[9999]">
    <!-- backdrop -->
    <div class="absolute inset-0 bg-black/70" @click="tutup" />

    <!-- modal wrapper: penuh layar -->
    <div class="relative z-10 flex w-screen h-screen p-4">
      <div class="relative flex flex-col w-full h-full overflow-hidden bg-white rounded-lg shadow-lg">
        <!-- header -->
        <div class="flex items-center justify-between px-4 py-2 border-b">
          <div class="font-semibold text-gray-700 truncate">
            {{ isPdf ? 'Pratinjau Dokumen' : 'Pratinjau Gambar' }}
          </div>
          <button
            class="px-3 py-1.5 text-sm font-semibold border border-red-500 text-red-500 rounded hover:bg-red-500 hover:text-white"
            @click="tutup"
            type="button"
          >
            Tutup
          </button>
        </div>

        <!-- LOADING LAYER -->
        <div
          v-if="isLoading"
          class="absolute inset-0 z-20 flex items-center justify-center bg-white/70"
        >
          <div class="w-10 h-10 border-4 border-gray-500 rounded-full animate-spin border-t-transparent"></div>
        </div>

        <!-- CONTENT AREA -->
        <div class="flex-1 min-h-0 overflow-auto bg-gray-50">

          <!-- PDF -->
          <iframe
            v-if="isPdf"
            :src="src"
            class="block w-full h-full"
            @load="finishLoading"
            @error="handleError"
          ></iframe>

          <!-- IMAGE -->
          <div v-else class="grid w-full h-full p-3 place-items-center">
            <img
              :src="src"
              class="block object-contain max-w-full max-h-full"
              @load="finishLoading"
              @error="handleError"
              alt="Pratinjau"
            />
          </div>

          <!-- ERROR MESSAGE -->
          <div v-if="hasError" class="p-6 text-center text-red-500">
            File tidak ditemukan atau tidak dapat ditampilkan.
          </div>
        </div>

        <!-- footer -->
        <div class="flex justify-end px-4 py-2 bg-white border-t">
          <button
            class="px-4 py-2 text-sm font-semibold text-red-500 border border-red-500 rounded hover:bg-red-500 hover:text-white"
            @click="tutup"
            type="button"
          >
            Tutup
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    showModal: { type: Boolean, default: false },
    src: { type: String, default: '' },
  },
  emits: ['close'],
  data() {
    return {
      isLoading: true,
      hasError: false,
    }
  },
  computed: {
    isPdf() {
      if (!this.src) return false
      const url = this.src.split('?')[0].toLowerCase()
      return url.endsWith('.pdf') || this.src.includes('application/pdf')
    },
  },
  watch: {
    src() {
      this.resetState()
    },
    showModal(val) {
      if (val) this.resetState()
    },
  },
  methods: {
    resetState() {
      this.isLoading = true
      this.hasError = false
    },
    tutup() {
      this.$emit('close')
    },
    finishLoading() {
      this.isLoading = false
    },
    handleError() {
      this.isLoading = false
      this.hasError = true
    },
  },
}
</script>
